import type { PropertiesTableProps } from '../../../../shared/types'
import { EditContainerProperties } from '../EditContainer/EditContainerDocs'

export const AnimatedContainerProperties: PropertiesTableProps = {
  ...EditContainerProperties,
}
